import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';

import { AdminTag, UserAdminTag, UserState } from 'us-web-services';
import UserAdminTagDisplay from './UserAdminTagDisplay';
import CardStyles from '../../styles/CardStyles';

interface Props {
  adminTags: AdminTag[];
  getUserAdminTags: () => any;
  lookupUser: UserState;
  userAdminTags: UserAdminTag[];
}

function UserAdminTags(props: Props) {
  const { lookupUser, adminTags, userAdminTags, getUserAdminTags } = props;
  const { classes } = CardStyles();

  return (
    <Card className={classes.sectionCard}>
      <CardContent className={classes.sectionContent}>
        <Typography className={classes.sectionHeader}>
          Admin Tags
        </Typography>
        <Grid container spacing={1}>
          {adminTags.length ? adminTags.map(tag => (
            <UserAdminTagDisplay
              key={tag.id}
              userId={lookupUser.user.id}
              tag={tag}
              getUserTags={getUserAdminTags}
              userAdminTags={userAdminTags}
            />
          )) : ''}
        </Grid>
      </CardContent>
    </Card>
  );
}

export default UserAdminTags;
